// import other library
import moment from 'moment';

// import local interfaces
import { InterfaceSelectedDetailTicketsComponent } from '../../../core/interface/booking/bookingComponent.interface';

// import local utils
import { numberWithCommas } from '../../../core/utils/utils';
import { bookingUtils } from '../bookingUtils';

export default function SelectedDetailTickets({
  showtimeInfo,
  selectedSeatList,
  setIsNotifyModalOpen,
  setStep,
}: InterfaceSelectedDetailTicketsComponent) {
  const getTotalPrice = () =>
    selectedSeatList.reduce((total, item) => total + item.giaVe, 0);

  const handleBookingConfirm = () => {
    if (selectedSeatList.length === 0) {
      setIsNotifyModalOpen(true);
      return;
    }
    setStep(2);
  };

  return (
    <div>
      <div className="flex flex-wrap sm:flex-nowrap justify-between border-t border-white/50 p-5">
        <img
          src={showtimeInfo.hinhAnh}
          alt={showtimeInfo.tenPhim}
          className="hidden sm:inline w-1/2 sm:w-28 md:w-32 object-cover"
        />
        <p className="w-full sm:w-1/6 mb-4 sm:mb-0 px-0 sm:px-3 uppercase font-semibold text-xl sm:text-lg lg:text-xl text-center sm:text-left">
          {showtimeInfo.tenPhim}
        </p>
        <div className="w-2/3 sm:w-auto text-[16px] lg:text-lg">
          <table>
            <tbody>
              <tr>
                <td className="pb-2 align-top">Rạp</td>
                <td className="pl-3 sm:pl-1 md:pl-4 pb-2 font-semibold">
                  {showtimeInfo.tenCumRap}
                </td>
              </tr>
              <tr>
                <td className="pb-2">Suất chiếu</td>
                <td className="pl-3 sm:pl-1 md:pl-4 pb-2 font-semibold">
                  {moment(showtimeInfo.ngayGioChieu).format(
                    'hh:mm, DD/MM/YYYY',
                  )}
                </td>
              </tr>
              <tr>
                <td className="pb-2">Phòng chiếu</td>
                <td className="pl-3 sm:pl-1 md:pl-4 pb-2 font-semibold align-top">
                  {showtimeInfo.tenRap}
                </td>
              </tr>
              <tr>
                <td className="pb-2">Ghế</td>
                <td className="pl-3 sm:pl-1 md:pl-4 pb-2 font-semibold">
                  {bookingUtils.renderSelectedSeat(selectedSeatList)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="w-1/3 sm:w-1/6 flex justify-end sm:justify-center font-semibold text-right text-lg sm:text-[16px] lg:text-lg">
          <div>
            <p className="mb-2">Tổng cộng:</p>
            <p className="mb-0">{numberWithCommas(getTotalPrice())} đ</p>
          </div>
        </div>
      </div>
      <button
        type="button"
        className="w-full px-5 py-2.5 bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-900 font-medium text-xl text-white transition duration-300"
        onClick={handleBookingConfirm}
      >
        XÁC NHẬN
      </button>
    </div>
  );
}
